<template>
<v-dialog
  v-model="isEditFormVisible"
  width="60%"
  persistent
>
  <v-card>
    <v-card-title>
      <span class="">Document</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="note"
              :value="cardio.note"
              class="title"
              @input="new_note = $event"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              label="URL"
              :value=cardio.url
              readonly
            ></v-text-field>
          </v-col>


          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              label="hostname"
              :value=cardio.hostname
              readonly
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              label="source"
              :value=cardio.source
              hint="example of helper text only on focus"
              readonly
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
          >
            <v-text-field
              label="owner_id"
              hint="example of persistent helper text"
              persistent-hint
              readonly
            ></v-text-field>
          </v-col>


          <v-col
            cols="12"
            sm="6"
          >
            <!--
            <v-select
              :items="['0-17', '18-29', '30-54', '54+']"
              label="Date Added"
            ></v-select> -->
            <v-text-field
            :value=cardio.created_time
            label="Date Added"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-autocomplete
              :items="['Biz', 'TeX', 'SocPol', 'Fin', 'Health', 'etc']"
              label="Tags"
              multiple
            ></v-autocomplete>
          </v-col>
        </v-row>


      </v-container>
      <small>*indicates required field</small>
    </v-card-text>

  <v-divider class="mt-12"></v-divider>
    
    <v-card-actions>
      <v-btn icon
        class="mx-5"
        @click="onFlipTrash"
      >
        <v-icon
        color="trashitcolor">
          delete
        </v-icon>
        Trash
      </v-btn>

    <v-spacer></v-spacer>

      <v-btn
        color="blue darken-1"
        text
        @click="closeForm()"
      >
        Close
      </v-btn>

      <v-btn
        color="orange darken-1"
        dark
        @click.stop="saveAndCloseForm()"
      >
        Save
      </v-btn>
    </v-card-actions>

  </v-card>

</v-dialog>
</template>



<script>
import msapi from '../api/mindsync'

export default {
  name: 'DocumentEditor',
  data: () => ({
    dialog: false,
    new_note: '',
  }),

  computed: {
    activeDoc () {
      return this.$store.getters['ui/activeDoc']
    },
    cardio() {
      console.log('-> calling cardio from DocumentEditor')
      if (!this.activeDoc) {
        console.log('|| missing activeDoc')
        return {}
      }
      var ret = this.$store.getters.included(this.activeDoc)
      return ret
    },
    isEditFormVisible: {
      get() {
        return this.$store.getters['ui/isEditFormVisible'];
      },
      set(value) {
        console.log(`isEditFormVisible new value is: ${value}`)
        // this.$store.dispatch('ui/closeEditForm')
      }
    },

    trashitcolor() {
      return this.cardio.trashit ? 'black' : '';
    },

  },
  beforeDestroy() {
    console.log('beforeDestroy')
    this.closeForm();
  },
  watch: {
    // activeDoc (new_val, old_val) {
    //   console.log(`> activeDoc: ${new_val} <- ${old_val}`)
    // },
    new_note () {
      // console.log(`> new_note: ${new_val} <- ${old_val}`)
    },
  },
  methods: {
    logIT (txt) {
      console.log(txt)
    },

    onFlipTrash() {
      var ret = this.$store.dispatch('flipTrashIt', this.activeDoc).then(response => {
          this.$store.dispatch('ui/raiseInfo', 'success: ' + response.status);
      }).catch(e => {
        this.$store.dispatch('ui/raiseError', e);
      });
      return ret;
    },

    closeForm () {
      console.log('=> calling closeForm')
      this.$store.dispatch('ui/closeEditForm') // closes the window
    },

    saveAndCloseForm () {
      console.log('=> calling saveAndCloseForm')

      var update_body = {'note': this.new_note}
      console.log(`=> update_body: ${update_body}`)
      msapi.putDoc(this.activeDoc, update_body).then(response => {
          console.log('msapi.putDoc: POST success');
          this.$store.dispatch('ui/raiseInfo', response.status === 200 ? 'success' : response.status);
          this.$store.dispatch('ui/closeEditForm');
      }).catch(e => {
        this.$store.dispatch('ui/raiseError', e);
      });
    }
  }
}

</script>
